module.exports = __webpack_public_path__ + "assets/img/6b9940318b952ed49f268ad2d8fd98ad.svg";